module.exports = __webpack_public_path__ + "static/icon-c96ede1c14bfcd744921838987183b30.png";